var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',_vm._b({staticClass:"mt-0",attrs:{"outlined":"","hide-details":"auto"},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'v-switch',{..._vm.input, ..._vm.$attrs},false))
}
var staticRenderFns = []

export { render, staticRenderFns }